<template>
  <svg :width="width" :height="height" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.9347 6.57313C19.5592 5.42747 21.4406 5.42742 22.0653 6.57313L26.2366 14.2155L33.8566 18.3924C34.43 18.7058 34.7853 19.3087 34.7857 19.9633L34.769 20.206C34.6932 20.7642 34.3583 21.2594 33.8566 21.5341L26.2366 25.7138L22.0653 33.3534C21.753 33.9277 21.1522 34.2853 20.5 34.2853L20.2572 34.2686C19.7012 34.1922 19.2076 33.8556 18.9347 33.3534L14.7634 25.7138L7.14341 21.5341C6.56995 21.2201 6.21428 20.6177 6.21428 19.9633C6.21455 19.3087 6.57 18.7058 7.14341 18.3924L14.7634 14.2155L18.9347 6.57313ZM18.0251 15.9956L17.5033 16.9498L16.5491 17.4716L12.0039 19.9633L16.5491 22.4577L17.5033 22.9794L20.5 28.4705L23.4966 22.9794L24.4509 22.4577L28.9933 19.9633L24.4509 17.4716L23.4966 16.9498L22.9749 15.9956L20.5 11.456L18.0251 15.9956Z" fill="url(#paint0_linear_14419_87127)"/>
    <path d="M37.2656 6.49117L35.1504 5.3301L33.9926 3.20726C33.7392 2.74081 32.9749 2.74081 32.7216 3.20726L31.5639 5.3301L29.4487 6.49117C29.2158 6.61909 29.0714 6.86367 29.0714 7.12919C29.0714 7.39507 29.2158 7.63965 29.4487 7.76714L31.5639 8.92793L32.7216 11.0508C32.8483 11.284 33.0925 11.4289 33.3571 11.4289C33.6218 11.4289 33.8659 11.284 33.9926 11.0508L35.1504 8.92793L37.2657 7.76714C37.4985 7.63972 37.6429 7.39514 37.6429 7.12919C37.6428 6.86367 37.4984 6.61909 37.2656 6.49117Z" fill="url(#paint1_linear_14419_87127)"/>
    <path d="M11.5513 32.205L9.43607 31.044L8.27828 28.9211C8.0249 28.4547 7.26061 28.4547 7.00731 28.9211L5.84959 31.044L3.73436 32.205C3.5015 32.333 3.35715 32.5775 3.35715 32.8431C3.35715 33.1089 3.5015 33.3535 3.73436 33.481L5.84959 34.6418L7.00731 36.7646C7.13396 36.9979 7.37817 37.1427 7.64283 37.1427C7.90749 37.1427 8.15162 36.9979 8.27835 36.7646L9.43614 34.6418L11.5514 33.481C11.7842 33.3536 11.9286 33.109 11.9286 32.8431C11.9285 32.5775 11.7842 32.333 11.5513 32.205Z" fill="url(#paint2_linear_14419_87127)"/>
    <defs>
      <linearGradient id="paint0_linear_14419_87127" x1="20.5" y1="5.71387" x2="20.5" y2="34.2853" gradientUnits="userSpaceOnUse">
        <stop stop-color="#762ECF"/>
        <stop offset="1" stop-color="#D62FA0"/>
      </linearGradient>
      <linearGradient id="paint1_linear_14419_87127" x1="33.3572" y1="2.85742" x2="33.3572" y2="11.4289" gradientUnits="userSpaceOnUse">
        <stop stop-color="#762ECF"/>
        <stop offset="1" stop-color="#D62FA0"/>
      </linearGradient>
      <linearGradient id="paint2_linear_14419_87127" x1="7.64286" y1="28.5713" x2="7.64286" y2="37.1427" gradientUnits="userSpaceOnUse">
        <stop stop-color="#762ECF"/>
        <stop offset="1" stop-color="#D62FA0"/>
      </linearGradient>
    </defs>
  </svg>


</template>

<script>
export default {
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false,
    },
    width: {
      required: false,
      type: Number,
      default: 31
    },
    height: {
      required: false,
      type: Number,
      default: 31
    }
  },
};
</script>
